<template>
  <div class="c-app">
    <CWrapper>
      <NavigationBar v-if="$route.meta.showHeader" />
      <div style="background-color: #FFFFFF;">
        <main class="c-main" style="padding-top: 0px">
          <transition name="fade">
            <router-view :class="[
              'page',
              $route.meta.showHeader ? null : 'no-header'
              ]"
            ></router-view>
          </transition>    
        </main>
      </div>
      <Footer v-if="$route.meta.showFooter" /> 
    </CWrapper>
  </div>
</template>

<script>
  import NavigationBar from "./NavigationBar";
  import Footer from "./Footer";

  export default {
    name: "Home",
    components: {
      NavigationBar,
      Footer,
    },
    data() {
      return {
      }
    },

  };
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  .page {
    padding-top: globalSharedVariables.$navbar-height;
    padding-left: 0;
    padding-right: 0;
    /* min-height: calc(100dvh - #{globalSharedVariables.$footerbar-height}); */
    min-height: 100dvh;
    color: #000000;

    &.no-header {
      padding-top: 0;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
